<template>
  <v-form ref="formEl">
    <h3 class="black--text mb-4">
      {{ isPolicy ? "Adicionar Apólice" : "Adicionar Proposta" }}
    </h3>
    <v-row>
      <v-col cols="12" md="6" class="pr-0 pr-sm-2">
        <BaseFormInput
          v-if="!isPolicy"
          id-element="input_numero_proposta"
          placeholder="Digite"
          v-model="editForm.numero_proposta"
          required
          validate-on-blur
          :rules="[requiredInput]"
          label-text="Nº Proposta"
        />
        <BaseFormInput
          v-if="isPolicy"
          id-element="input_numero_apolice"
          placeholder="Digite"
          v-model="editForm.numero_apolice"
          required
          validate-on-blur
          :rules="[requiredInput]"
          label-text="Nº Apólice"
        />
      </v-col>
      <v-col cols="12" md="3" class="pr-0 pr-sm-2">
        <BaseFormInput
          id-element="input_inicio_vigencia"
          placeholder="DD/MM/AAAA"
          v-model="editForm.inicio_vigencia"
          required
          :rules="[requiredInput, dateTermValid]"
          validate-on-blur
          v-facade="maskDate"
          label-text="Início Vigência"
        />
      </v-col>
      <v-col cols="12" md="3" class="pr-0 pr-sm-2">
        <BaseFormInput
          id-element="input_fim_vigencia"
          placeholder="DD/MM/AAAA"
          v-model="editForm.fim_vigencia"
          required
          :rules="[requiredInput, dateTermValid]"
          validate-on-blur
          v-facade="maskDate"
          label-text="Fim Vigência"
        />
      </v-col>
      <v-col cols="12" class="pb-5">
        <v-divider />
      </v-col>
    </v-row>

    <v-row>
      <QuotationProposalAgricola
        v-if="product == 'agricola'"
        :editForm="editForm"
        :readonly="isPolicy"
      />
      <QuotationProposalCafezal
        v-if="product == 'cafezal'"
        :editForm="editForm"
        :readonly="isPolicy"
      />
    </v-row>

    <v-row v-if="!isPolicy">
      <v-col cols="12" md="6" class="pr-0 pr-sm-2 pb-2">
        <p class="body-2 font-weight-bold primary--text mb-2">
          Arquivo Proposta
        </p>
        <DropFile
          @selected-files="addProposalFile"
          class="mb-5"
          v-if="!hasMainFile"
        />
        <DocumentDataTable
          :documents="editForm.arquivo_proposta"
          @remove-file="removeProposalFile"
          @preview-file="onPreviewFile"
          v-if="hasMainFile"
        />
      </v-col>
      <v-col cols="12" md="6" class="pr-0 pr-sm-2 pb-2">
        <p class="body-2 font-weight-bold primary--text mb-2">
          Arquivo Boleto
        </p>
        <DropFile
          @selected-files="addBillingFile"
          class="mb-5"
          v-if="!hasBillingFile"
        />
        <DocumentDataTable
          :documents="editForm.arquivo_boleto"
          @remove-file="removeBillingFile"
          @preview-file="onPreviewFile"
          v-if="hasBillingFile"
        />
      </v-col>
    </v-row>
    <v-row v-if="isPolicy">
      <v-col cols="12" md="6" class="pr-0 pr-sm-2 pb-2">
        <p class="body-2 font-weight-bold primary--text mb-2">
          Arquivo Apólice
        </p>
        <DropFile
          @selected-files="addPolicyFile"
          class="mb-5"
          v-if="!hasMainFile"
        />
        <DocumentDataTable
          :documents="editForm.arquivo_apolice"
          @remove-file="removePolicyFile"
          @preview-file="onPreviewFile"
          v-if="hasMainFile"
        />
      </v-col>
      <v-col cols="12" md="6" class="pr-0 pr-sm-2 pb-2">
        <p class="body-2 font-weight-bold primary--text mb-2">
          Arquivo Boleto
        </p>
        <DropFile
          @selected-files="addFilesBills"
          class="mb-5"
          :multiple="true"
        />
        <DocumentDataTable
          :documents="editForm.arquivo_boleto"
          @remove-file="onRemoveFileBills"
          @preview-file="onPreviewFile"
          v-if="hasBills && hasBillingFile"
        />
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { formatIsoDateToDDMMYYYY } from "@/utils/formats.js";
import DropFile from "@/components/DropFile.vue";
import DocumentDataTable from "@/components/DocumentDataTable";
import { FILE } from "@/mixins/DocumentsMixin";
import DocumentsMixin from "@/mixins/DocumentsMixin";
import { requiredInput, dateTermValid } from "@/utils/rules.js";
import { maskDate } from "@/utils/masks.js";
import _ from "lodash";
import QuotationProposalAgricola from "./QuotationProposalAgricola.vue";
import QuotationProposalCafezal from "./QuotationProposalCafezal.vue";
import { mapActions } from "vuex";

export default {
  name: "QuotationeditForm",
  mixins: [DocumentsMixin],
  components: {
    DropFile,
    DocumentDataTable,
    QuotationProposalAgricola,
    QuotationProposalCafezal
  },
  data() {
    return {
      formatIsoDateToDDMMYYYY,
      requiredInput,
      dateTermValid,
      maskDate,
      editForm: null,
      hasMainFile: false,
      hasBillingFile: false
    };
  },
  async created() {
    this.loadForm(this.form);
    if (this.navigationDraft) {
      this.editForm = _.cloneDeep(this.navigationDraft);
      const mainFiles = this.isPolicy
        ? this.editForm.arquivo_apolice
        : this.editForm.arquivo_proposta;
      this.hasMainFile = mainFiles?.length > 0;
      this.hasBillingFile = this.editForm.arquivo_boleto?.length > 0;
    }
  },
  methods: {
    ...mapActions(["hasLoading", "showAlertNotification"]),
    loadForm(form) {
      this.editForm = _.cloneDeep(form);

      if (this.editForm.forma_pagamento?.id != null) {
        this.editForm.forma_pagamento.id = this.editForm.forma_pagamento.id.toString();
      }

      if (this.editForm.inicio_vigencia != null) {
        this.editForm.inicio_vigencia = formatIsoDateToDDMMYYYY(
          this.editForm.inicio_vigencia
        );
      }

      if (this.editForm.fim_vigencia != null) {
        this.editForm.fim_vigencia = formatIsoDateToDDMMYYYY(
          this.editForm.fim_vigencia
        );
      }
      if (this.isPolicy) {
        if (!this.editForm.arquivo_apolice_link) {
          this.editForm.arquivo_apolice = [];
        } else {
          this.editForm.arquivo_apolice = [
            {
              url: this.editForm.arquivo_apolice_link,
              nome: this.editForm.arquivo_apolice_nome
            }
          ];
          this.hasMainFile = true;
        }
      } else {
        if (!this.editForm.arquivo_link) {
          this.editForm.arquivo_proposta = [];
        } else {
          this.editForm.arquivo_proposta = [
            {
              url: this.editForm.arquivo_link,
              nome: this.editForm.arquivo_nome
            }
          ];

          this.hasMainFile = true;
        }
      }
      if (!this.editForm.boleto_link) {
        this.editForm.arquivo_boleto = [];
      } else {
        if (this.isPolicy) {
          this.editForm.arquivo_boleto = _.cloneDeep(this.editForm.boletos);
        } else {
          this.editForm.arquivo_boleto = [
            {
              url: this.editForm?.boleto_link,
              nome: this.editForm.boleto_nome
            }
          ];
        }
        this.hasBillingFile = true;
      }
    },
    checkDuplicateFile(file, type) {
      let fileName = file.name;
      if (type == "proposal" || type == "billing") {
        let proposalFileNames = new Set(
          this.editForm.arquivo_proposta?.map(
            item => item.arquivo?.nome || item.nome
          ) || []
        );
        let billingFileNames = new Set(
          this.editForm.arquivo_boleto?.map(
            item => item.arquivo?.nome || item.nome
          ) || []
        );
        if (proposalFileNames.has(fileName) || billingFileNames.has(fileName)) {
          return true;
        }
      }

      if (type == "policy" || type == "bills") {
        let policyFileNames = new Set(
          this.editForm.arquivo_apolice?.map(
            item => item.arquivo?.nome || item.nome
          ) || []
        );
        let billsFileNames = new Set(
          this.editForm.arquivo_boleto?.map(
            x => x.nome || x.arquivo?.nome || []
          )
        );
        if (billsFileNames.has(fileName) || policyFileNames.has(fileName)) {
          return true;
        }
      }
      return false;
    },
    addProposalFile(files) {
      if (this.checkDuplicateFile(files[0], "proposal")) {
        this.showAlertNotification({
          message: "Nome de arquivo duplicado da Proposta com o Boleto!",
          type: "error"
        });
        return;
      }
      this.editForm.arquivo_proposta = files.map(file => ({
        arquivo: {
          [FILE]: file,
          nome: file.name
        }
      }));

      this.hasMainFile = true;
    },
    addPolicyFile(files) {
      if (this.checkDuplicateFile(files[0], "policy")) {
        this.showAlertNotification({
          message: "Nome de arquivo duplicado da Apólice com o Boleto!",
          type: "error"
        });
        return;
      }
      this.editForm.arquivo_apolice = files.map(file => ({
        arquivo: {
          [FILE]: file,
          nome: file.name
        }
      }));

      this.hasMainFile = true;
    },
    addBillingFile(files) {
      if (this.checkDuplicateFile(files[0], "billing")) {
        this.showAlertNotification({
          message:
            "Nome de arquivo inserido duplicado do Boleto com a Proposta!",
          type: "error"
        });
        return;
      }
      this.editForm.arquivo_boleto = files.map(file => ({
        arquivo: {
          [FILE]: file,
          nome: file.name
        }
      }));
      this.hasBillingFile = true;
    },
    removeProposalFile() {
      this.editForm.arquivo_proposta = [];
      this.hasMainFile = false;
    },
    removePolicyFile() {
      this.editForm.arquivo_apolice = [];
      this.hasMainFile = false;
    },
    removeBillingFile() {
      this.editForm.arquivo_boleto = [];
      this.hasBillingFile = false;
    },
    addFilesBills(files) {
      if (this.checkDuplicateFile(files[0], "bills")) {
        this.showAlertNotification({
          message:
            "Nome de arquivo inserido duplicado do Boleto com a Apólice!",
          type: "error"
        });
        return;
      }
      const uniqueFileNames = new Set(
        this.editForm.arquivo_boleto.map(x => x.nome || x.arquivo.nome)
      );
      this.editForm.arquivo_boleto = this.editForm.arquivo_boleto.concat(
        files
          .filter(file => !uniqueFileNames.has(file.name))
          .map(file => ({
            arquivo: {
              [FILE]: file,
              nome: file.name
            }
          }))
      );
      this.hasBillingFile = true;
      this.forceFormUpdate();
    },
    onRemoveFileBills(item) {
      this.editForm.arquivo_boleto = this.editForm.arquivo_boleto.filter(
        document =>
          document.arquivo
            ? document.arquivo.nome !== item.arquivo?.nome
            : document.nome !== item.nome
      );
      this.forceFormUpdate();
    },
    forceFormUpdate() {
      // vue não está detectando alteração no form qdo edita essa propriedade.
      if (this.editForm == null) {
        return;
      }
      this.editForm = _.cloneDeep(this.editForm);
    },
    validate() {
      if (!this.$refs.formEl.validate()) {
        return "Preencha todos os campos corretamente para prosseguir.";
      }

      let txError = "";

      if (!this.editForm.area_segurada > 0) {
        txError += "Àrea Segurada deve ser maior do que zero.";
      }

      if (!this.isPolicy && !this.editForm.arquivo_proposta.length > 0) {
        txError += "Necessário anexar a Proposta para prosseguir.";
      }

      if (this.isPolicy && !this.editForm.arquivo_apolice.length > 0) {
        txError += "Necessário anexar a Apólice para prosseguir.";
      }

      if (!this.editForm.arquivo_boleto.length > 0) {
        txError += "Necessário anexar o Boleto para prosseguir.";
      }

      if (
        this.editForm.inicio_vigencia != null &&
        this.editForm.fim_vigencia != null
      ) {
        let inicio = new Date(this.editForm.inicio_vigencia);
        let fim = new Date(this.editForm.fim_vigencia);
        if (fim.getTime() <= inicio.getTime()) {
          txError +=
            "Data 'Fim Vigência' deve ser maior que 'Início Vigência'.";
        }
      }

      //Validadores Agrícola
      if (this.product == "agricola") {
        if (!this.editForm.importancia_segurada > 0) {
          txError += "Importância Segurada deve ser maior do que zero.";
        }

        if (!this.editForm.producao_garantida > 0) {
          txError += "Produção Garantida deve ser maior do que zero.";
        }

        if (this.isInsuranceTypeProductivity) {
          if (!this.editForm.custo_por_saca > 0) {
            txError += "Custo por Saca deve ser maior do que zero.";
          }
        } else {
          if (!this.editForm.custo_por_hectare > 0) {
            txError += "Custo por Hectare deve ser maior do que zero.";
          }
        }

        if (!this.editForm.custo_total > 0) {
          txError += "Custo Total deve ser maior do que zero.";
        }

        if (!this.editForm.custo_segurado > 0) {
          txError += "Custo Segurado deve ser maior do que zero.";
        }

        if (!this.editForm.custo_produtor > 0) {
          txError += "Custo Produtor deve ser maior do que zero.";
        }
      }

      // Validadores de Cafezal
      if (this.product == "cafezal") {
        if (!this.editForm.valor_planta > 0) {
          txError += "O Valor da Planta deve ser maior do que zero.";
        }

        if (!this.editForm.granizo > 0 && !this.editForm.granizo_geada > 0) {
          txError += "O valor da cobertura básica deve ser maior do que zero.";
        }

        if (!this.editForm.premio_total > 0) {
          txError += "O valor do Prêmio Total deve ser maior do que zero.";
        }

        if (!this.editForm.premio_segurado > 0) {
          txError += "Prêmio do Segurado deve ser maior do que zero.";
        }

        if (!this.editForm.premio_segurado > 0) {
          txError += "O valor do Investimento deve ser maior do que zero.";
        }
      }

      if (txError.length == 0) {
        return true;
      }

      return txError;
    }
  },
  computed: {
    isInsuranceTypeProductivity() {
      return this.editForm.tipo_seguro?.id == "produtividade";
    },
    hasBills() {
      return (
        this.editForm.arquivo_boleto && this.editForm.arquivo_boleto.length > 0
      );
    }
  },
  props: {
    navigationDraft: {
      type: Object
    },
    isPolicy: {
      type: Boolean,
      default: false
    },
    form: {
      type: Object
    },
    product: {
      type: String
    }
  }
};
</script>
